import React from 'react'
import { Modal, Button, Form, Input } from 'antd'

const { TextArea } = Input

const RejectSaqueModal = (props) => {
    const { 
        visible, 
        handleCancel, 
        handleReject, 
        saqueId,
        isSubmit 
    } = props
    
    const [form] = Form.useForm()
    
    const onFinish = (values) => {
        handleReject(saqueId, values.motivo)
    }
    
    // Clear form when modal closes
    const handleModalCancel = () => {
        form.resetFields()
        handleCancel()
    }
    
    return (
        <Modal
            title="Rejeitar Solicitação de Saque"
            open={visible}
            onCancel={handleModalCancel}
            footer={null}
        >
            <Form 
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    label="Motivo da Rejeição"
                    name="motivo"
                    rules={[
                        { 
                            required: true, 
                            message: 'Por favor, informe o motivo da rejeição' 
                        },
                        {
                            min: 10,
                            message: 'O motivo deve conter no mínimo 10 caracteres'
                        }
                    ]}
                >
                    <TextArea 
                        rows={4} 
                        placeholder="Informe o motivo da rejeição" 
                    />
                </Form.Item>
                
                <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                    <Button 
                        style={{ marginRight: 8 }} 
                        onClick={handleModalCancel}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        type="primary" 
                        htmlType="submit" 
                        danger
                        loading={isSubmit}
                    >
                        Rejeitar
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default RejectSaqueModal 